import React from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import spokeIcon from "../../../assets/icons/Spoke.svg";

const TypeIcon = ({ type, size = 16, color = "var(--app-text-muted)" }) => {
  const normalized = type?.toLowerCase();

  if (normalized === "hub") {
    return (
      <Icon
        icon="mingcute:hospital-fill"
        width={size}
        height={size}
        style={{ color }}
      />
    );
  }

  if (normalized === "spoke") {
    return (
      <Box
        component="img"
        src={spokeIcon}
        alt="spoke-icon"
        sx={{ width: size, height: size }}
      />
    );
  }

  return null;
};

export default TypeIcon;